/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

export const StaleValueContainer = styled.div({
  background: 'none',
  border: 'none',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  cursor: 'default',
});

export const CardInfoContainer = styled.div({
  padding: token('space.200'),
  maxWidth: '300px',
});

export const MobileHiddenInlineBlock = styled.div(
  media.upToSmall(`
    display: none;
  `),
  {
    display: 'inline-block',
  }
);
